// src/components/WebPlayback.js
import { useState, useEffect } from 'react';
import SpotifyWebApi from 'spotify-web-api-js';

const spotifyApi = new SpotifyWebApi();

const WebPlayback = ({ token }) => {
  const [player, setPlayer] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [current_track, setCurrentTrack] = useState(null);
  const [device_id, setDeviceId] = useState(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://sdk.scdn.co/spotify-player.js";
    script.async = true;

    document.body.appendChild(script);

    window.onSpotifyWebPlaybackSDKReady = () => {
      const player = new window.Spotify.Player({
        name: 'Web Player',
        getOAuthToken: cb => { cb(token); },
        volume: 0.5
      });

      setPlayer(player);

      player.addListener('ready', ({ device_id }) => {
        console.log('Ready with Device ID', device_id);
        setDeviceId(device_id);
        
        // Transfer playback to this device
        spotifyApi.setAccessToken(token);
        spotifyApi.transferMyPlayback([device_id])
          .then(() => {
            console.log('Transferred playback to web player');
          })
          .catch(err => console.error('Error transferring playback:', err));
      });

      player.addListener('not_ready', ({ device_id }) => {
        console.log('Device ID has gone offline', device_id);
      });

      player.addListener('player_state_changed', (state => {
        if (!state) {
          return;
        }

        setCurrentTrack(state.track_window.current_track);
        setIsActive(true);
      }));

      player.connect();
    };
  }, [token]);

  return null; // This component doesn't render anything
};

export default WebPlayback;
